import React from 'react';
import { Upload, Zap, CreditCard } from 'lucide-react';
const SolutionSection = () => {
  return <section id="how-it-works" className="section" data-id="element-349">
      <div className="container" data-id="element-350">
        <div className="text-center mb-16" data-id="element-351">
          <h2 className="font-outfit font-bold text-3xl md:text-4xl mb-6" data-id="element-352">
            How Settl Works
          </h2>
          <p className="text-slate-grey text-lg max-w-3xl mx-auto" data-id="element-353">
            We've simplified bill payments into three easy steps, giving you
            back time and improving your cash flow.
          </p>
        </div>
        <div className="relative" data-id="element-354">
          {/* Connecting Line */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 border-t-2 border-dashed border-settl-blue border-opacity-30 z-0" data-id="element-355"></div>
          {/* Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10" data-id="element-356">
            {/* Step 1 */}
            <div className="card flex flex-col items-center text-center" data-id="element-357">
              <div className="flex justify-center items-center w-16 h-16 rounded-full bg-settl-blue text-white text-xl font-bold mb-6" data-id="element-358">
                1
              </div>
              <div className="bg-light-sky p-3 rounded-full mb-6" data-id="element-359">
                <Upload className="h-8 w-8 text-settl-blue" data-id="element-360" />
              </div>
              <h3 className="font-outfit font-semibold text-xl mb-4" data-id="element-361">
                Upload Your Bills
              </h3>
              <p className="text-slate-grey mb-4" data-id="element-362">
                Simply upload invoices via our portal, email, or WhatsApp. We
                support all formats and vendor types.
              </p>
              <ul className="text-left text-sm space-y-2" data-id="element-363">
                <li className="flex items-start" data-id="element-364">
                  <span className="text-success-green mr-2" data-id="element-365">✓</span>
                  <span data-id="element-366">Manual upload or auto-forwarding</span>
                </li>
                <li className="flex items-start" data-id="element-367">
                  <span className="text-success-green mr-2" data-id="element-368">✓</span>
                  <span data-id="element-369">Automatic data extraction</span>
                </li>
                <li className="flex items-start" data-id="element-370">
                  <span className="text-success-green mr-2" data-id="element-371">✓</span>
                  <span data-id="element-372">Duplicate detection</span>
                </li>
              </ul>
            </div>
            {/* Step 2 */}
            <div className="card flex flex-col items-center text-center" data-id="element-373">
              <div className="flex justify-center items-center w-16 h-16 rounded-full bg-settl-blue text-white text-xl font-bold mb-6" data-id="element-374">
                2
              </div>
              <div className="bg-light-sky p-3 rounded-full mb-6" data-id="element-375">
                <Zap className="h-8 w-8 text-settl-blue" data-id="element-376" />
              </div>
              <h3 className="font-outfit font-semibold text-xl mb-4" data-id="element-377">
                We Pay Immediately
              </h3>
              <p className="text-slate-grey mb-4" data-id="element-378">
                Settl pays your vendors right away after approval, ensuring
                on-time payments and happy suppliers.
              </p>
              <ul className="text-left text-sm space-y-2" data-id="element-379">
                <li className="flex items-start" data-id="element-380">
                  <span className="text-success-green mr-2" data-id="element-381">✓</span>
                  <span data-id="element-382">Same-day vendor payments</span>
                </li>
                <li className="flex items-start" data-id="element-383">
                  <span className="text-success-green mr-2" data-id="element-384">✓</span>
                  <span data-id="element-385">All payment methods supported</span>
                </li>
                <li className="flex items-start" data-id="element-386">
                  <span className="text-success-green mr-2" data-id="element-387">✓</span>
                  <span data-id="element-388">Automatic payment confirmation</span>
                </li>
              </ul>
            </div>
            {/* Step 3 */}
            <div className="card flex flex-col items-center text-center" data-id="element-389">
              <div className="flex justify-center items-center w-16 h-16 rounded-full bg-settl-blue text-white text-xl font-bold mb-6" data-id="element-390">
                3
              </div>
              <div className="bg-light-sky p-3 rounded-full mb-6" data-id="element-391">
                <CreditCard className="h-8 w-8 text-settl-blue" data-id="element-392" />
              </div>
              <h3 className="font-outfit font-semibold text-xl mb-4" data-id="element-393">
                You Pay Us in 30 Days
              </h3>
              <p className="text-slate-grey mb-4" data-id="element-394">
                Enjoy 30 days to pay us back with a single consolidated payment,
                improving your cash flow.
              </p>
              <ul className="text-left text-sm space-y-2" data-id="element-395">
                <li className="flex items-start" data-id="element-396">
                  <span className="text-success-green mr-2" data-id="element-397">✓</span>
                  <span data-id="element-398">One monthly statement</span>
                </li>
                <li className="flex items-start" data-id="element-399">
                  <span className="text-success-green mr-2" data-id="element-400">✓</span>
                  <span data-id="element-401">Flexible payment methods</span>
                </li>
                <li className="flex items-start" data-id="element-402">
                  <span className="text-success-green mr-2" data-id="element-403">✓</span>
                  <span data-id="element-404">Extended payment terms</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-405">
          <a href="https://wa.me/60127743934/?text=I%20am%20interested%20in%20Settl" className="btn-primary" data-id="element-406">
            Get Started Today
          </a>
        </div>
      </div>
    </section>;
};
export default SolutionSection;